// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36CJq","type":"styles_type__3GueK","choices":"styles_choices__1JGvI"};